/* @flow weak */
import * as React from 'react';

import Button from 'components/ButtonDeprecated';
import Container from 'components/Container';
import TitleHeader from 'components/TitleHeader';
import LinkDeviceModal from 'user/components/LinkDeviceModal';
import ModalTrigger from 'components/ModalTrigger';

import './styles/PhoneCallAddNumberPage.scss';

type Props = {
  onDone: Function,
};

class PhoneCallAddNumberPage extends React.Component<Props> {
  render() {
    return (
      <Container size="medium" className="PhoneCallAddNumberPage">
        <TitleHeader
          image={require('assets/images/phoneCalls/phone-tab-null.svg')}
          imageSize="xxsmall"
          title="Make calls as easily as you send Remind messages"
          subtext="Keep calls safe with anonymized phone numbers and automatic logging."
          size="medium"
          action={
            <ModalTrigger
              modal={
                <LinkDeviceModal
                  skipUpdateDevicePreferences
                  onDone={this.props.onDone}
                  deviceType="phoneNumber"
                />
              }>
              <Button eventElementName="add_phone_number_button">Add your phone number</Button>
            </ModalTrigger>
          }
        />
      </Container>
    );
  }
}
export default PhoneCallAddNumberPage;
